/**
 * OmmnioSign date display format (DD-MM-YYYY).
 */

export function formatOmmnioSignDate(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) {
    return '';
  }
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export function normalizeOmmnioSignDate(value) {
  if (value == null || value === '') return value ?? '';
  if (value instanceof Date) {
    return formatOmmnioSignDate(value);
  }
  if (typeof value !== 'string') {
    return String(value);
  }
  const trimmed = value.trim();
  if (/^\d{2}-\d{2}-\d{4}$/.test(trimmed)) {
    return trimmed;
  }
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}-${isoMatch[2]}-${isoMatch[1]}`;
  }
  const parsed = new Date(trimmed);
  if (!Number.isNaN(parsed.getTime())) {
    return formatOmmnioSignDate(parsed);
  }
  return trimmed;
}
